export const BUTTON_WIDTH = 60;
export const BUTTON_HEIGHT = 60;
export const BUTTON_LEFT = 12;
export const BUTTON_RIGHT = 12;
export const BUTTON_TOP = 40;
export const MARGIN_BOTTOM = 18;

export default {
    BUTTON_HEIGHT,
    BUTTON_WIDTH,
    BUTTON_LEFT,
    BUTTON_RIGHT,
    BUTTON_TOP,
    MARGIN_BOTTOM,
};
